// Sidhuvudet i flödet skapa konto, välj plan och betala (designen
// Web-Betalning). Skapa konto sker på webbplatsen, resten i kontot (ADR 0091).
import { Marke } from '../../layout/ikoner.js';

const STEG = ['Skapa konto', 'Välj plan', 'Betala med kort'] as const;

function Bock() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m5 12 5 5 9-10" />
    </svg>
  );
}

/** `aktivt` är steget man är på. Ett värde efter sista steget betyder att alla är klara. */
export function FlodesHuvud({ aktivt }: { aktivt: number }) {
  const klart = aktivt >= STEG.length;
  return (
    <header className="kom-igang-huvud">
      <span className="marke">
        <Marke />
        LeadLedger
      </span>
      <ol className="steg" aria-label={klart ? 'Steg, alla klara' : 'Steg'}>
        {STEG.map((namn, i) => (
          <li
            key={namn}
            className={i < aktivt ? 'klart' : i === aktivt ? 'aktivt' : undefined}
            aria-current={i === aktivt ? 'step' : undefined}
          >
            <span className="punkt" aria-hidden="true">
              {i < aktivt ? <Bock /> : i + 1}
            </span>
            {namn}
            {i < aktivt && <span className="visuellt-dold"> (klart)</span>}
          </li>
        ))}
      </ol>
      {/* LeadLedgers enda adress (ADR 0086). Designen visar hjalp@. */}
      <a href="mailto:info@leadledger.se">Frågor? info@leadledger.se</a>
    </header>
  );
}
